import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Login from './Components/Pages/Login/Login';
import AddAnalysis from './Components/Pages/ViewApplication/AddAnalysis';
import UploadApplication from './Components/Pages/UploadApplication/UploadApplication';

import ViewApplication from './Components/Pages/ViewApplication/ViewApplication';
import Report from './Components/Pages/Reports/Reports';
import ViewAnalysis from './Components/Pages/ViewApplication/ViewAnalysis';

import AddEmployee from './Components/Pages/Employee/AddEmployee';
import "bootstrap/dist/css/bootstrap.min.css";
import { AuthProvider } from './Components/Contextapi/ContextApi';
import ProtectedRoute from './Components/ProtectedRoute/ProtectedRoute';
import Dashboard from './Components/Pages/Dashboard/Dashboard';
import ViewEmployee from './Components/Pages/Employee/ViewEmployee';
import ChangePassword from './Components/Pages/ChangePassword/ChangePassword';
function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
          <Route element={<ProtectedRoute />}>

            <Route path="/upload" element={<UploadApplication />} />
            <Route path="/view" element={<ViewApplication />} />
            <Route path="/addanalysis/:id" element={<AddAnalysis />} />
            <Route path="/viewanalysis/:id" element={<ViewAnalysis />} />
            <Route path="/report" element={<Report />} />

            <Route path="/addEmployee" element={<AddEmployee />} />
            <Route path="/Viewemployee" element={<ViewEmployee />} />

            <Route path="/edit-employee/:id" element={<AddEmployee />} />

            <Route path="/dashboard" element={<Dashboard />} />
             <Route path="/change-password" element={<ChangePassword />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
